<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm' }} phiếu điều chỉnh số lượng vật tư</h1>
          <div style="float: right">
            <button type="button" @click="$router.push('/quantity-material')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <div>
                <div v-if="dataRequest.id" class="form-group row">
                  <label class="col-sm-3 col-form-label">Tên kho </label>
                  <div class="col-sm-9">
                    {{ dataRequest.inventoryNameExport }}
                  </div>
                </div>
                <ValidationProvider
                  rules="required"
                  vid="inventoryId"
                  name="Tên kho"
                  v-if="!dataRequest.id"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Tên kho {{ dataRequest.id }}<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2
                        @change="
                          (dataRequest.inventoryId = inventoryId),
                            fetchDeviceActive(),
                            checkChange(inventoryId)
                        "
                        :disabled="!!dataRequest.id"
                        v-model="inventoryId"
                        :options="warehouseUserActiveData"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <ValidationProvider rules="minMaxName_6" vid="description" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Ghi chú</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
      <div v-if="dataRequest.inventoryId">
        <div class="addDevice mb-2 ml-2">
          <h6>Danh sách thiết bị</h6>
          <div>
            <button @click="showModalRequestDevice()" class="btn btn-success btn-primary ml-3 mr-4">
              Thêm thiết bị
            </button>
          </div>
        </div>
        <div class="row tableDevice">
          <div class="table-responsive text-center">
            <table class="table table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col"><b>Mã vật tư</b></th>
                  <th scope="col"><b>Tên vật tư</b></th>
                  <th scope="col"><b>Thời điểm ghi nhận</b></th>
                  <th scope="col"><b>SL trên hệ thống</b></th>
                  <th scope="col"><b>SL thực tế</b></th>
                  <th scope="col"><b>Điều chỉnh</b></th>
                  <th scope="col"><b>Ghi chú</b></th>
                  <th scope="col"><b>Hành động</b></th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="(item, index) in listMaterial" :key="index">
                  <td class="text-center">{{ item.abbreviation }}</td>
                  <td class="text-center">
                    <span> {{ item.categoryName }}</span>
                  </td>
                  <td class="text-center">
                    <span>{{ item.dateConfirm | formatDate('HH:mm, DD/MM/YYYY') }}</span>
                  </td>
                  <td class="text-center">{{ item.beforeChangeQuantity }}</td>
                  <td class="text-center">{{ item.afterChangeQuantity }}</td>
                  <td class="text-center">
                    {{
                      item.afterChangeQuantity - item.beforeChangeQuantity < 0 ? 'Giảm:' : 'Tăng:'
                    }}
                    {{ Math.abs(item.afterChangeQuantity - item.beforeChangeQuantity) }}
                  </td>
                  <td class="text-center">{{ item.note }}</td>
                  <td class="text-center">
                    <b-dropdown class="text-center" variant="outline-light">
                      <b-dropdown-item class="dropdown-item" @click="deleteDevice(index)"
                        ><span>&nbsp;</span>Xóa
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <modalRequestMaterial
      v-if="isShowModalRequestDevice"
      :closeModalRequestDevice="closeModalRequestDevice"
      :dataSerial="listDevice"
      :lsData="dataDevice"
      @updateDevice="updateDevice"
      :inventoryId="dataRequest.inventoryId"
    />
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'
  import modalRequestMaterial from './modalRequestMaterial.vue'
  import pick from 'lodash/pick'
  export default {
    name: 'quantity-material-request',
    data() {
      return {
        Config,
        dataRequest: {},
        showLoading: false,
        warehouseUserActiveData: [],
        listDevice: [],
        listMaterial: [],
        dataDevice: {},
        isShowModalRequestDevice: false,
        inventoryId: '',
      }
    },
    components: { modalRequestMaterial },
    created() {
      if (this.$route.params.id) {
        this.fetchData()
      } else this.fetchWarehouse()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        dataSearch: 'search/getDataSearchOther',
      }),
    },
    methods: {
      async submitRequest() {
        if (this.listMaterial.length === 0) {
          this.showFailMx('Vui lòng thêm vật tư')
          return
        }
        const params = this.preareDataAddWarranty()
        try {
          this.showLoading = true
          if (this.dataRequest.id) {
            params.id = this.dataRequest.id
            const response = await DeviceService.updateOrderQuantityMaterial(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật phiếu điều chỉnh số lượng vật tư thành công').then(() =>
                this.$router.push('/quantity-material')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await DeviceService.createOrderQuantityMaterial(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới phiếu điều chỉnh số lượng vật tư thành công').then(() =>
                this.$router.push('/quantity-material')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      preareDataAddWarranty() {
        const balanceDeviceReqList = this.listMaterial.map(item => {
          return pick(item, [
            'note',
            'changeQuantity',
            'afterChangeQuantity',
            'beforeChangeQuantity',
            'categoryId',
            'dateConfirm',
          ])
        })
        const dataPreare = {
          balanceDeviceReqList,
          inventoryId: this.dataRequest.inventoryId,
          note: this.dataRequest.note,
          dateImportAndExport: Date.now(),
        }
        return dataPreare
      },
      async fetchData() {
        const id = this.$route.params.id
        if (id) {
          try {
            this.showLoading = true
            const responsive = await DeviceService.detailQuantityMaterial({ id })
            if (responsive.code === 1000) {
              this.inventoryId = responsive.data.inventoryIdExport
              this.dataRequest = responsive.data
              this.dataRequest.inventoryId = responsive.data.inventoryIdExport
              this.dataRequest.note = responsive.data.description
              this.listMaterial = responsive.data.devices.map(item => {
                return {
                  categoryId: item.categoryId,
                  abbreviation: item.abbreviation,
                  categoryName: item.categoryName,
                  dateConfirm: item.dateConfirm,
                  beforeChangeQuantity: item.beforeChangeQuantity,
                  note: item.noteImport ? item.noteImport : item.noteExport,
                  afterChangeQuantity: item.afterChangeQuantity,
                  changeQuantity: '',
                  edit: true,
                }
              })
              this.fetchDeviceActive()
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
      async fetchWarehouse() {
        try {
          this.showLoading = true
          const response = await DeviceService.getListWarehouseUserActive()
          this.warehouseUserActiveData = response.data.map(
            ({ id, name, level, regions, cityCode }) => {
              return { id, text: name, level, regions, cityCode }
            }
          )
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async fetchDeviceActive() {
        try {
          const data = {
            kind: 'NORMAL',
          }
          this.showLoading = true
          const res = await DeviceService.deviceKindNomal(data)
          this.listDevice = res.data.map(({ id, name, abbreviation }) => {
            return { id, text: name, abbreviation }
          })
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async updateDevice(data) {
        if (data.edit === true) {
          const dataFindIndex = this.listMaterial.findIndex(item => item.deviceId === data.deviceId)
          if (dataFindIndex !== -1) {
            const dataUpdate = { ...this.listMaterial[dataFindIndex], ...data }
            delete dataUpdate.edit
            this.listMaterial.splice(dataFindIndex, 1, dataUpdate)
          }
        } else {
          this.listMaterial.push(data)
        }
        this.$bvModal.hide('request-device-material')
        this.isShowModalRequestDevice = false
      },

      async closeModalRequestDevice() {
        this.$bvModal.hide('request-device-material')
        this.isShowModalRequestDevice = false
      },
      showModalRequestDevice() {
        const data = { edit: false }
        this.dataDevice = data
        this.isShowModalRequestDevice = true
        this.$nextTick(s => this.$bvModal.show('request-device-material'))
      },
      deleteDevice(index) {
        this.listMaterial.splice(index, 1)
      },
      checkChange(newVal) {
        if (this.listMaterial.length > 0) {
          this.listMaterial = []
          this.dataRequest.inventoryId = newVal
        } else {
          this.dataRequest.inventoryId = newVal
        }
      },
    },
  }
</script>

<style scoped>
  .addDevice {
    display: flex;
    justify-content: space-between;
  }
  .tableDevice {
    min-height: 145px;
  }
</style>
